define(function(require, exports, module) {
    'use strict';

    var AnimationManager = require('managers/animation.manager');

    module.exports = new AnimationManager();
});
